module.exports = __webpack_public_path__ + "static/media/rosaLinnMedia10.28af9459.jpg";